import { Dimensions, Platform, findNodeHandle } from 'react-native';
import * as R from 'unitx/ramda';
export const IS_NATIVE = R.includes(Platform.OS, ['android', 'ios']);
export { default as download } from "./download/default";
export const seperateContainerStyle = style => {
  const containerStyle = {
    alignItems: 'center',
    justifyContent: 'center'
  };
  const selectionKeys = ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'border'];
  return R.ifElse(R.isNil, R.always({
    container: containerStyle,
    component: {
      width: '100%',
      height: '100%'
    }
  }), R.always({
    container: R.pick(selectionKeys, R.mergeRight(style, containerStyle)),
    component: R.mergeRight(R.omit(selectionKeys, style), {
      width: '100%',
      height: '100%'
    })
  }))(style);
};
export const calculateFontSize = (width, fontSize) => R.ifElse(R.allPass([R.isString, R.includes('%')]), R.pipe(R.replace('%', ''), parseFloat, R.divide(100), R.multiply(width)), R.always(fontSize))(fontSize); // eslint-disable-next-line react/no-find-dom-node

export const findNode = ref => findNodeHandle(ref.current);
export const ratioOnScreen = value => {
  const ScreenLayout = Dimensions.get('screen');
  return {
    width: value / ScreenLayout.width * 100,
    height: value / ScreenLayout.height * 100
  };
};
export const inverseRatioOnScreen = value => {
  const ScreenLayout = Dimensions.get('screen');
  return {
    width: value * 100 / ScreenLayout.width,
    height: value * 100 / ScreenLayout.height
  };
};
export const ratioLayout = (layout, ratio = 1) => {
  const {
    width,
    height
  } = layout;
  const scaledLayout = {
    width,
    height
  };
  const minLength = R.min(width, height);
  return R.cond([[R.equals(width), R.always(R.set(R.lensProp('height'), width / ratio, scaledLayout))], [R.T, R.always(R.set(R.lensProp('height'), height / ratio, scaledLayout))]])(minLength);
};
export const childOf = (c, p) => {
  // eslint-disable-next-line functional/no-loop-statement
  while (c === c.parentNode && c !== p);

  return !!c;
};
export const makeNativeEvent = event => {
  const mutableEvent = event;
  R.when(R.isNil, () => {
    // @ts-ignore
    mutableEvent.persist = () => {};
  } // @ts-ignore
  )(mutableEvent.persist);
  R.when(R.isNil, () => {
    // @ts-ignore
    mutableEvent.nativeEvent = event;
  } // @ts-ignore
  )(mutableEvent.nativeEvent);
  return mutableEvent;
};
export const wrapDomEventHandler = callback => e => callback(makeNativeEvent(e));
const NativeEventMapToDomEvent = {
  onLongPress: ['onLongPress'],
  onPress: ['onClick'],
  onDoublePress: ['onDoubleClick'],
  onPressChange: ['onPressChange'],
  onPressStart: ['onMouseDown'],
  onPressMove: ['onMouseMove'],
  onPressEnd: ['onMouseUp'],
  onBlur: ['onBlur'],
  onFocus: ['onFocus'],
  onHover: ['onHover'],
  onHoverStart: ['onMouseOver'],
  onHoverEnd: ['onMouseOut']
};
export const makeDomEvents = (events = {}, extraWrapper = R.identity) => R.pipe(R.toPairs, R.map(([eventName, handler]) => [NativeEventMapToDomEvent[eventName][0], extraWrapper(wrapDomEventHandler(handler))]), R.fromPairs)(events);
export const filterEvents = (events = {}) => R.omitBy( // @ts-ignore
(handler, eventName) => !NativeEventMapToDomEvent[eventName])(events);
export const isCollide = (item, otherItem) => {
  const posA = item.position;
  const sizeA = item.size;
  const posB = otherItem.position;
  const sizeB = otherItem.size;
  return !(posA.y + sizeA.height < posB.y || posA.y > posB.y + sizeB.height || posA.x + sizeA.width < posB.x || posA.x > posB.x + sizeB.width);
};
export const isInside = (rec1, rec2, {
  allInside
} = {
  allInside: false
}) => R.ifElse(R.isTrue, () => R.allPass([R.always(rec1.position.x < rec2.position.x), R.always(rec1.position.y < rec2.position.y), R.always(rec1.position.x + rec1.size.width > rec2.position.x), R.always(rec1.position.y + rec1.size.height > rec2.position.y), R.always(rec1.position.x + rec1.size.width > rec2.position.x + rec2.size.width), R.always(rec1.position.y + rec1.size.height > rec2.position.y + rec2.size.height)])(''), () => R.allPass([R.always(rec1.position.x < rec2.position.x), R.always(rec1.position.y < rec2.position.y), R.always(rec1.position.x + rec1.size.width > rec2.position.x), R.always(rec1.position.y + rec1.size.height > rec2.position.y)])(''))(allInside);
export const wait = async time => {
  const res = await new Promise(res => {
    setTimeout(() => {
      res();
    }, time);
  });
  return res;
};
export const readTextFile = async (blob, encoding) => new Promise((res, rej) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => {
    const {
      result
    } = reader; // @ts-ignore

    res(result);
  });
  reader.addEventListener('error', error => {
    rej(error);
  });
  reader.readAsText(blob, encoding);
});